<template>
    <div class="page-table mainDiv">
        <div class="card-base baslikBg" v-if="this.selectIcon===0">{{$t("src.views.apps.iletisim.liste.tumu")}}</div>
        <div class="card-base baslikBg" v-if="this.selectIcon===1">{{$t("src.views.apps.iletisim.liste.yeni")}}</div>
        <div class="card-base baslikBg" v-if="this.selectIcon===2">{{$t("src.views.apps.iletisim.liste.okundu")}}</div>
        <div class="card-base baslikBg" v-if="this.selectIcon===3">{{$t("src.views.apps.iletisim.liste.arsiv")}}</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col :span="24">
                <div>
                    <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                    text-color="gray">
                        <el-radio-button label="1">
                            <i class="mdi mdi-email mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="this.selectIcon===1">{{$t("src.views.apps.iletisim.liste.yeni")}}</label>
                            </transition>
                        </el-radio-button>
                        <el-radio-button label="2">
                            <i class="mdi mdi-email-open mdi-18px" style="color: #f7ba2a; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="this.selectIcon===2">{{$t("src.views.apps.iletisim.liste.okundu")}}</label>
                            </transition>
                        </el-radio-button>
                        <el-radio-button label="3">
                            <i class="mdi mdi-email mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="this.selectIcon===3">{{$t("src.views.apps.iletisim.liste.arsiv")}}</label>
                            </transition>
                        </el-radio-button>
                        <el-radio-button label="0">
                            <i class="mdi mdi-email-mark-as-unread mdi-18px"
                               style="color: #0075c3; margin-right: 5px"></i>
                            <transition name="slide-fade"><label
                                    v-if="this.selectIcon===0">{{$t("src.views.apps.iletisim.liste.tumu")}}</label>
                            </transition>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>
            <el-table
                    v-loading="loading"
                    :data="iletisimListe"
                    ref="filterTable"
                    style="width: 100%">
                <el-table-column
                        sortable
                        prop="adSoyad"
                        label="İsim Soyisim"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="telefon"
                        label="Telefon"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="eposta"
                        label="E-Posta"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="auto">
                    <template slot-scope="scope">
                        <el-tooltip :content='$t("src.views.apps.iletisim.liste.detay")'
                                    :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    type="text"

                                    @click="iletisimDetay(scope.row)"
                                    icon="mdi mdi-email-search mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <!--<el-tooltip :content='$t("src.views.apps.iletisim.liste.detay")'-->
                        <!--:open-delay="500"-->
                        <!--placement="bottom">-->
                        <!--<el-button-->
                        <!--type="primary"-->
                        <!--size="mini"-->
                        <!--@click="notDialog = true; selection = scope.row; selectionIndex = scope.$index"-->
                        <!--icon="mdi mdi-comment-outline">-->
                        <!--</el-button>-->
                        <!--</el-tooltip>-->
                        <el-tooltip :content='$t("src.views.apps.iletisim.liste.arsiv")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon !==3 && scope.row.durum  !=='3'"
                                    @click="arsivDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    class="buttonDel"
                                    type="text"
                                    icon="mdi mdi-delete mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.iletisim.liste.uyari")'
                :visible.sync="arsivDialogVisible"
                width="30%"
                center>
            <span>"{{selection.adSoyad}}" {{$t('src.views.apps.iletisim.liste.alertP')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="iletisimArsiv(selection,selectionIndex,iletisimListe), arsivDialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="arsivDialogVisible = false"></el-button>
            </span>
        </el-dialog>
        <!--<el-dialog-->
        <!--title=''-->
        <!--:visible.sync="notDialog"-->
        <!--width="30%"-->
        <!--center>-->
        <!--<el-form :model="form" ref="form">-->
        <!--<el-form-item label='Not'>-->
        <!--<el-input type="textarea" v-model="form.not"></el-input>-->
        <!--</el-form-item>-->
        <!--</el-form>-->
        <!--</el-dialog>-->
        <el-drawer
                title=""
                :visible.sync="drawer"
                size="40%"
                :with-header="false">
            <div class="flex center demo-box">
                <div class="right-box box grow">
                    <dl class="horizontal" style="padding: 10px">
                        <dt>Ad Soyad</dt>
                        <dd> : {{musteri.adSoyad}}</dd>
                        <el-divider></el-divider>
                        <dt>Telefon</dt>
                        <dd> : {{musteri.telefon}}</dd>
                        <el-divider></el-divider>
                        <dt>E-Posta</dt>
                        <dd> : {{musteri.eposta}}</dd>
                        <el-divider></el-divider>
                        <dt>Mesaj</dt>
                        <dd> : {{musteri.mesaj}}</dd>
                        <el-divider></el-divider>
                    </dl>
                </div>
            </div>
        </el-drawer>

    </div>
</template>

<script>
    import iletisimService from '../../../WSProvider/IletisimService';
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataEstas = "";
    export default {
        name: "SiparisListesi",
        data() {
            return {
                page: 0,
                sizes: 10,
                postPage: '',
                total: null,
                drawer: false,
                notDialog: false,
                musteri: [],
                form:{
                    not:''
                },
                loading: false,
                arsivDialogVisible: false,
                selection: '',
                selectionIndex: '',
                iletisimListe: [],
                selectIcon: 1,
                radio: '1',
            }
        },
        watch: {
            page(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getIletisimList(this.selectIcon, this.postPage, this.sizes);
            },
        },
        mounted() {
            if (localStorage.getItem("userDataEstas")) {
                userDataEstas = JSON.parse(base64.decode(localStorage.getItem("userDataEstas")));
            }
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getIletisimList(this.selectIcon, this.postPage, this.sizes);
            },
            handleChange(event) {
                this.loading = true;
                this.selectIcon = parseInt(event);
                this.postPage = 0;
                this.getIletisimList(this.selectIcon, this.postPage, this.sizes);
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getIletisimList(this.selectIcon, this.postPage, this.sizes);
            },
            getIletisimList(durum, baslangici, limit) {
                let self = this;
                iletisimService.iletisimList(durum, baslangici, limit).then((response) => {
                    if (response.status === 200) {
                        this.iletisimListe = response.data;
                        setTimeout(function () {
                            self.loading = false;
                        }, 1000);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            iletisimDetay(selection) {
                iletisimService.iletisimDetay(selection.iletisimId).then((response) => {
                    if (response.status === 200) {
                        console.log(response);
                        this.musteri = response.data;
                        this.drawer = true;
                    }
                })
            },
            iletisimArsiv(selection, index, list) {
                iletisimService.iletisimArsiv(selection.iletisimId).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'İşlem başarıyla gerçekleşti.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label{
        position: relative;
        bottom: 5px;
    }
</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .el-radio-button--mini .el-radio-button__inner{
        padding: 0 10px !important;
        font-size: 11px;
        border-radius: 0;
    }
    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>